<template>
      <v-col>
          <v-snackbar
            v-model="emailSnackbar"
            timeout="2000"
            top
          >
            e-mail został wysłany
          </v-snackbar>

          <v-card flat>
         <v-data-table
            :key="componentKey"
            :headers="computedHeaders"
            :items="tableItems"
            class="elevation-1"
            :loading="paymentsLoadStatus===1"
            :options.sync="tableOptions"
            :server-items-length="options.lineCount"
            hide-default-footer
            must-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Kasa</v-toolbar-title>
                
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <!-- <v-select label="Status" clearable v-model="selectedStatus"  class="choose_status" :items="lookups.paymentsStatus" hide-details ></v-select>

                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider> -->

                

                 <v-menu
                                      v-model="selectedDayMenu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="150px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-model="selectedDay"
                                          clearable
                                          label="Data"
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-on="on"
                                          class="choose_date mt-6 mr-5"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker first-day-of-week="1" v-model="selectedDay" @input="selectedDayMenu = false"></v-date-picker>
                </v-menu>
               
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Wyszukaj"
                      single-line
                      hide-details
                      class="search"
                      @keydown.enter="searchPayments"
                  ></v-text-field>
                  </template>
                    <span>Wpisz min 3 znaki i naciśnij Enter</span>
                </v-tooltip>
                 

                <v-spacer></v-spacer>

                <v-checkbox v-model="showDeleted" class="mt-4" label="Pokaż wyłączone"></v-checkbox>

                <v-divider
                  v-if="user.permissions['payment'] >= 10"
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
               <v-dialog v-if="user.permissions['payment'] >= 10" v-model="dialog" :max-width="itemViewing?'1000px':'1400px'">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small class="mb-2 mt-2" fab dark color="primary">
                      <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <v-card  :loading="paymentAddStatus===1 || paymentEditLoadStatus===1 || paymentEditStatus===1">
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                      <v-spacer></v-spacer>

                        <v-menu  bottom left close-on-click min-width="250" max-width="250">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-on="on" v-bind="attrs" size="28" @click="sendFileLoad" >mdi-email-send-outline</v-icon>
                          </template>

                          <v-list>
                            <v-list-item v-if="childLoadStatus==1">
                              <v-list-item class="align-center">
                                <v-progress-circular
                                    
                                    indeterminate
                                    color="primary"
                                  ></v-progress-circular>
                              </v-list-item>
                            </v-list-item>
                            <v-list-item v-else-if="childLoadStatus==2 && ownersWithEmail.length==0">
                              <v-list-item-title>Brak adresów e-mail</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              two-line
                              v-else
                              v-for="(item, i) in ownersWithEmail"
                              :key="i"
                              @click="sendFile(item)"
                            >
                            <v-list-item-content>
                              <v-list-item-title>{{ item.email }}</v-list-item-title>
                               <v-list-item-subtitle>{{ item.name }}</v-list-item-subtitle>
                               </v-list-item-content>
                                <v-list-item-action v-if="item.default">
                                    <v-icon color="grey lighten-1">mdi-account-check-outline</v-icon>
                                </v-list-item-action>
                            </v-list-item>
                            
                          </v-list>
                        </v-menu>

                      <!-- <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            size="28"
                            class="ml-5"
                            :disabled="!itemEditing && !paymentEditing"
                            @click="sendFile"
                          >
                            mdi-email-send-outline
                          </v-icon>
                        </template>
                        <span>Wyślij e-mail</span>
                      </v-tooltip> -->


                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            size="28"
                            class="ml-5"
                            :disabled="!itemEditing && !paymentEditing"
                            @click="printFile"
                          >
                            mdi-printer
                          </v-icon>
                        </template>
                        <span>Drukuj</span>
                      </v-tooltip>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        
                           <v-row>                   
                            <v-col :class="itemViewing?'col-6':'col-5'">
                              <v-card flat class="elevation-1 pb-2" height="130px" style="background-color: #f4f4f4;">
                                <v-toolbar flat  dense style="background-color: #f4f4f4;">
                                    <v-toolbar-title>Dziecko</v-toolbar-title>
                                </v-toolbar>
                                <v-text-field v-if="itemEditing || paymentEditing"  v-model="editedItemChildName" readonly class="ml-4 mr-4" ></v-text-field>

                                <v-autocomplete
                                  v-else
                                  :error-messages="child_idErrors"
                                  :readonly="editedItem.child.id !== undefined"
                                  v-model="editedItem.child.id"
                                  :loading="childrenLookupLoadStatus == 1"
                                  :items="childrenLookup"
                                  :search-input.sync="searchReference"
                                  class="ml-4 mr-4"
                                  flat
                                  hide-no-data
                                  label="Wyszukaj dziecko"
                                  clearable
                                ></v-autocomplete>

                              </v-card>
                            </v-col>
                            <v-col v-if="!itemViewing" class="col-1"> </v-col>
                            <v-col class="col-6">
                                <v-card flat class="elevation-1 pb-2" height="130px"  style="background-color: #f4f4f4;">
                                <v-toolbar flat  dense style="background-color: #f4f4f4;">
                                    <v-toolbar-title>{{itemEditing || paymentEditing?'Numer dokumentu':'Rodzaj dokumentu'}}</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-title style="color:red;" v-if="editedItem.status==20"><b>STORNO</b></v-toolbar-title>
                               
                                </v-toolbar>
                                    <v-text-field 
                                    v-if="itemEditing || paymentEditing"  
                                    v-model="editedItem.document_number" 
                                    readonly 
                                    hide-details 
                                    class="ml-4 mr-4" 
                                    ></v-text-field>

                                <v-select v-else v-model="editedItem.type" class="ml-4 mr-4" :items="types" hide-details ></v-select>
                                
                                <h4 v-if="itemEditing || paymentEditing" class="mt-2 mr-4 text-end">{{editedItem.created_at}} / {{editedItem.created_by}}</h4>
                              </v-card>
                            </v-col>
                          </v-row>


                          <v-row>
                            <v-col  v-if="!itemViewing" class="col-5">
                              <v-card flat class="elevation-1">
                                <v-data-table
                                  :headers="editedItem.type=='KP'?headersSettlements:headersSettlementsKW"
                                  :items="tableSettlements"
                                  class="elevation-0"
                                  item-key="id"
                                  show-select
                                  v-model="selectedSettlements"
                                  dense
                                  hide-default-footer
                                  disable-pagination
                                  :sort-by="['year','month']"
                                  style="background-color: #f4f4f4;"
                                  :loading="settlementsLoadStatus===1"
                                >

                                  <template v-slot:top>
                                    <v-toolbar flat style="background-color: #f4f4f4;" dense>
                                      <v-toolbar-title v-if="editedItem.type=='KP'">Pozycje do rozliczenia</v-toolbar-title>
                                      <v-toolbar-title v-else>Pozycje rozliczone</v-toolbar-title>
                                    </v-toolbar>
                                  </template>
                                  <template  v-slot:item.month="{ item }">
                                    {{ monthName(item.month) }}
                                  </template>
                                  <template  v-slot:item.amount="{ item }">
                                    {{ $n(item.amount-item.posted_without_document, 'currency', 'pl-PL') }} ({{$n(item.fix+item.hour-item.posted_stay_without_document, 'decimal', 'pl-PL')}}/{{$n(item.fix_meal+item.meal-item.posted_meal_without_document, 'decimal', 'pl-PL')}}/{{$n(item.fix_other+item.other-item.posted_other_without_document, 'decimal', 'pl-PL')}})
                                  </template>

                                  <template v-if="editedItem.type=='KW'" v-slot:item.balance="{ item }">
                                    {{ $n(item.posted, 'currency', 'pl-PL') }}
                                  </template>

                                  <template v-slot:header.data-table-select></template>

                                  <template v-if="tableSettlements.length>0" slot="body.append">
                                      <tr class="v-data-table__selected font-weight-medium subheading">
                                              <td></td>
                                              <td>Suma</td>
                                              <td>{{ $n(sumFieldSettlements('amount')-sumFieldSettlements('posted_without_document'), 'currency', 'pl-PL')}}</td>
                                              <td v-if="editedItem.type=='KW'">{{ $n(sumFieldSettlements('posted'), 'currency', 'pl-PL')}}</td>
                                      </tr>
                                  </template>

                                </v-data-table>
                              </v-card>
                            </v-col>
                            <v-col  v-if="!itemViewing" class="col-1">
                              <v-row
                                align="center"
                                justify="center"
                                class="fill-height flex-column"
                              >
                                <v-btn
                                  :disabled="selectedSettlements.length < 1"
                                  @click="addSettlementToDocument"
                                  depressed
                                  color="success"
                                  class="mt-5 mb-5"
                                  small
                                  >Dodaj<v-icon right dark
                                    >mdi-arrow-right-bold-outline</v-icon
                                  ></v-btn
                                >

                                <v-btn
                                  :disabled="selectedSelected.length < 1"
                                  @click="deleteSettlementFromDocument"
                                  depressed
                                  color="warning"
                                  class="mt-5 mb-5"
                                  small
                                  ><v-icon left dark>mdi-arrow-left-bold-outline</v-icon
                                  >Usuń</v-btn
                                >
                              </v-row>
                            </v-col>
                            <v-col :class="itemViewing?'col-12':'col-6'">
                               <v-card flat class="elevation-1">
                                <v-data-table
                                  :headers="editedItem.type=='KP'?headersSelected:headersSelectedKW"
                                  :items="tableSelected"
                                  class="elevation-0"
                                  item-key="id"
                                  show-select
                                  v-model="selectedSelected"
                                  dense
                                  hide-default-footer
                                  disable-pagination
                                  :sort-by="['year','month']"
                                  style="background-color: #f4f4f4;"
                                >

                                  <template v-slot:top>
                                    <v-toolbar flat style="background-color: #f4f4f4;" dense>
                                      <v-toolbar-title v-if="!itemViewing">Pozycje wybrane do dokumentu</v-toolbar-title>
                                      <v-toolbar-title v-else>Pozycje dokumentu</v-toolbar-title>
                                      <span class="error--text v-messages text-end">{{selectedErrors}}</span>
                                    </v-toolbar>
                                  </template>
                                  <template  v-slot:item.month="{ item }">
                                    {{ monthName(item.month) }}
                                  </template>
                                  
                                  <template v-slot:item.amount="{ item }">
                                    {{ $n(item.amount-item.posted_without_document, 'currency', 'pl-PL') }} ({{$n(item.fix+item.hour-item.posted_stay_without_document, 'decimal', 'pl-PL')}}/{{$n(item.fix_meal+item.meal-item.posted_meal_without_document, 'decimal', 'pl-PL')}}/{{$n(item.fix_other+item.other-item.posted_other_without_document, 'decimal', 'pl-PL')}})
                                  </template>
                                  <!-- <template v-else v-slot:item.amount="{ item }">
                                    {{ $n(item.posted_without_document, 'currency', 'pl-PL') }}
                                  </template> -->
                                  <template v-slot:item.payed="{ item }">
                                    <template v-if="!$v.$invalid">{{ $n(item.payed, 'currency', 'pl-PL') }} ({{$n(item.payed_stay, 'decimal', 'pl-PL')}}/{{$n(item.payed_meal, 'decimal', 'pl-PL')}}/{{$n(item.payed_other, 'decimal', 'pl-PL')}})</template>
                                  </template>

                                  <template v-slot:header.data-table-select></template>
                                  <template v-if="itemViewing" v-slot:item.data-table-select></template>

                                   <template v-if="tableSelected.length>0" slot="body.append">
                                      <tr class="v-data-table__selected font-weight-medium subheading">
                                              <td></td><td></td>
                                              <td>Suma</td>
                                              <td>{{ $n(sumField('amount')-sumField('posted_without_document'), 'currency', 'pl-PL')}}</td>
                                              <!-- <td v-else>{{ $n(sumField('posted_without_document'), 'currency', 'pl-PL')}}</td> -->
                                              <td>{{ !$v.$invalid?$n(sumField('payed'), 'currency', 'pl-PL'):''}}</td>
                                      </tr>
                                  </template>
                                </v-data-table>
                              </v-card>
                              
                                <div class="d-flex flex-row-reverse mt-2"> 
                                  <div class="d-flex flex-row align-center" style="width:250px;">
                                      <h4 v-if="editedItem.type=='KP'" class="mr-5">Wpłata:</h4>
                                      <h4 v-else class="mr-5">Wypłata:</h4>
                                      
                                      <v-text-field
                                          v-if="itemViewing"
                                          readonly
                                          v-model="editedItemAmountCur"
                                          class="mt-2"
                                        ></v-text-field>
                                      <v-text-field
                                          v-else
                                          v-model="editedItem.amount"
                                          class="mt-2"
                                          @input="amountInput"
                                          :error-messages="amountErrors"
                                          @blur="$v.editedItem.amount.$touch()"
                                        ></v-text-field>
                                    </div>
                                    
                                </div>
                            </v-col>
                          </v-row>
                      </v-container>
                    </v-card-text>

                    

                    <v-card-actions>
                      
                      <v-spacer></v-spacer>
                      <v-btn color="red" text @click="stornItem(editedItem.id)" v-if="itemViewing && editedItem.status!=20">Storno</v-btn>
                      <v-btn color="gray" text @click="close">{{itemViewing?'Zamknij':'Wyjdź'}}</v-btn>
                      
                      <v-btn color="primary darken-1" text @click="handleSubmit" v-if="!itemViewing" >{{itemEditing || paymentEditing?'Zapisz':'Zatwierdź'}}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <!-- <v-dialog v-if="user.permissions['payment'] >= 10" v-model="dialogEmail">
                  <v-card  :loading="childLoadStatus===1">
                    <v-card-title>
                      <span class="headline">Wybór opiekuna</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        
                           <v-row>                   
                            <v-col>
                              
                            </v-col>
                          </v-row>
                      </v-container>
                    </v-card-text>

                    

                    <v-card-actions>
                      
                      <v-spacer></v-spacer>
                      <v-btn color="gray" text @click="closeEmail">Anuluj</v-btn>
                      <v-btn color="primary darken-1" text @click="handleSubmitEmail" >Wyślij</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog> -->

              </v-toolbar>
            </template>

            <template  v-slot:item.amount="{ item }">
                {{ $n(item.amount, 'currency', 'pl-PL') }}
             </template>

             <template v-slot:item.child="{ item }">
              <template v-if="item.child">{{item.child.name+' '+item.child.surname}}</template>
            </template>

            <template v-slot:item.status2="{ item }">
              <span :style="item.status=='Storno'?'color:red;':''" >{{item.status}}</span>
              <span v-if="item.status=='Storno'"> (<v-btn small text class="pl-0 pr-0" @click="viewItem(item.storn)">{{item.storn.document_number}}</v-btn>)</span>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-tooltip v-if="item.can_delete && user.permissions['payment'] >= 10" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    @click="editItem(item)"
                  >
                    mdi-pencil
                  </v-icon>
                  </template>
                    <span>Edytuj</span>
                </v-tooltip>

                <v-tooltip v-if="item.active && item.can_delete && user.permissions['payment'] >= 10" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class=""
                    @click="deleteItem(item)"
                  >
                    mdi-delete
                  </v-icon>
                  </template>
                  <span>Wyłącz</span>
                </v-tooltip>

                <v-btn @click="viewItem(item)" v-if="!item.can_delete && user.permissions['payment'] >= 5" color="primary" x-small>Podgląd</v-btn>
             
                
            </template> 

            <template v-slot:item.status="{ item }">
              <v-simple-checkbox v-model="item.active" disabled></v-simple-checkbox>
            </template>



          </v-data-table> 
          <div class="text-center pt-2">
            <v-btn @click="loadMore" v-if="!options.itemAdded && options.lineCount-tableItems.length>0 && paymentsLoadStatus===2" small color="primary"><v-icon left>mdi-download</v-icon>Załaduj więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadPayments" v-else-if="options.itemAdded && options.lineCount-tableItems.length>0" small color="primary"><v-icon left>mdi-reload</v-icon>Odśwież tabele aby móc załadować więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadPayments" v-else-if="options.itemSearched" small color="primary"><v-icon left>mdi-reload</v-icon>Anuluj wyszukiwanie</v-btn>
          
          </div>

          </v-card>
      
      <confirm ref="confirm"></confirm>
      </v-col>
      

</template>

<script>
  import Vue from 'vue'
  import i18n from "../main";
  import confirm from '../components/Confirm'
  import minLength from 'vuelidate/lib/validators/minLength'
  import minValue from 'vuelidate/lib/validators/minValue'
  import maxValue from 'vuelidate/lib/validators/maxValue'
  import required from 'vuelidate/lib/validators/required'
  import decimal from 'vuelidate/lib/validators/decimal'
  import { helpers } from 'vuelidate/lib/validators'
  const decimalPL = helpers.regex('decimalPL', /^[-]?\d*(\,\d+)?$/)

  import jsPDF from 'jspdf'
  import logusLogo from '../plugins/jspdf_resources'
  import 'jspdf-autotable'

  export default {
    components:{
      confirm
    },
    data: () => ({
      items: [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' },
      ],
      emailSnackbar:false,
      componentKey:0,
      tableOptions: {},
      selectedDayMenu:false,
      dialog: false,
      dialogEmail:false,
      itemEditing:false,
      itemViewing:false,
      search:'',
      searchReference: null,
      itemWasDefault:false,
      //selectedSettlements:[],
      selectedSelected:[],
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp',filterable:false,display:true},
        { text: 'Data', value: 'date',filterable:false,filterColumn:"date",display:true },
        //{ text: 'Rodzaj', value: 'type',filterable:true },
        { text: 'Nr dokumentu', value: 'document_number',filterable:true,filterColumn:"number",display:true },
        //{ text: 'Nr RK', value: 'rk',filterable:true },
        
        { text: 'Dziecko', value: 'child',filterable:true,sortable: false,filterColumn:"child.name",display:true },
        { text: 'Dziecko', value: 'child.surname',filterable:true,sortable: false,filterColumn:"child.surname",display:false },
        { text: 'Kwota', value: 'amount',filterable:true,filterColumn:"amount",display:true },
        { text: 'Status', value: 'status2',filterable:false,display:true },
        { text: 'Zatwierdził', value: 'created_by',filterable:true,display:true,filterColumn:"created_by" },
        { text: 'Aktywne', value: 'status',filterable:false,sortable: false,display:true },
        { text: 'Akcje', value: 'actions', sortable: false,filterable:false,display:true },
      ],
       headersSettlements: [
        { text: 'Miesiąc', value: 'month',sortable: false },
        { text: 'Cennik', value: 'rates',sortable: false },
        { text: 'Do zapłaty (P/Ż/I)', value: 'amount',sortable: false},
        { text: '',value:'data-table-select',sortable: false}
      ],
      headersSettlementsKW: [
        { text: 'Miesiąc', value: 'month',sortable: false },
        { text: 'Cennik', value: 'rates',sortable: false },
        { text: 'Do zapłaty (P/Ż/I)', value: 'amount',sortable: false},
        { text: 'Wpłacono', value: 'balance',sortable: false},
        { text: '',value:'data-table-select',sortable: false}
      ],
       headersSelected: [
        { text: 'Miesiąc', value: 'month',sortable: false },
        { text: 'Cennik', value: 'rates',sortable: false },
        { text: 'Do zapłaty (P/Ż/I)', value: 'amount',sortable: false},
        { text: 'Wpłacono (P/Ż/I)', value: 'payed',sortable: false},
      ],
       headersSelectedKW: [
        { text: 'Miesiąc', value: 'month',sortable: false },
        { text: 'Cennik', value: 'rates',sortable: false },
        { text: 'Do zapłaty', value: 'amount',sortable: false},
        { text: 'Wypłacono', value: 'payed',sortable: false},
      ],
      types:[
        {value:'KP',text:'KP - Kasa Przyjmie'},
        {value:'KW',text:'KW - Kasa Wyda'}
      ]
    }),
    validations() {
      return {
        editedItemAmountDec:{
          //maxValue:maxValue(this.maxValue),
          minValue:minValue(0.01)
        },
        editedItem:{
          // name: {
          //   required,
          //   maxLength:maxLength(20),
          // },
          selected:{
            required,
            minLength: minLength(1),
          },
          amount:{
            required,
            decimalPL,

          },
          child:{
            id:{
              required
            }
          }
        }
      }
    },
    watch: {
      tableOptions: {
        handler () {
          var currentOptions = {...this.options};
          const { sortBy, sortDesc } = this.tableOptions
        
          //zmiana sortowania
          if (sortBy.length === 1 && sortDesc.length === 1) {
            currentOptions.orderBy = Vue._.find(this.headers,{'value':sortBy[0]}).filterColumn;
            currentOptions.orderDirection = sortDesc[0]?'desc':'asc';
            this.options = currentOptions;
          } 
        },
        deep: true,
      },
      editedItemChildId(val){//tylko przy dodawaniu nowych
         if(this.itemViewing)return;

         if(!this.itemEditing){
           if(val){
            this.$store.dispatch( 'loadSettlementsForChild', {
              child_id:val,
              document_id:this.editedItem.id,
              type:this.editedItem.type
             });
           }else{//domyśle ustawienia formatki
              this.searchReference = null
              this.selectedSettlements = []
              this.selectedSelected = []
              this.$v.$reset()
              setTimeout(() => {
                this.$store.dispatch( 'loadPaymentEditDefault'); 
                this.$store.dispatch( 'loadPaymentAddDefault');
              }, 300)
           }
           
         }
      },
      editedItemType(val){//tylko przy dodawaniu nowych
         if(!this.itemEditing){
           if(this.editedItem.child.id){//tylko jak już jest dziecko
           this.editedItem.selected = [];
            this.$store.dispatch( 'loadSettlementsForChild', {
              child_id:this.editedItem.child.id,
              document_id:this.editedItem.id,
              type:val
             });
           }
         }
      },
      searchReference(val) {
        val &&
          val !== this.editedItem.child.id &&
          !this.editedItem.child.id &&
          val.length > 2 &&
          this.querySelectionsReference(val);
      },
      dialog (val) {
        this.$v.$reset()
        val || this.close()
      },
      dialogEmail (val) {
        //this.$v.$reset()
        val || this.closeEmail()
      },
      paymentEditStatus(val){
        if(val===2){
          //this.close();
          //this.componentKey += 1;
        }
      },
      paymentAddStatus(val){
        if(val===2){
          //this.close();
          //this.componentKey += 1;
        }
      },
      paymentSendDocumentStatus(val){
        if(val===2){
          this.emailSnackbar = true;
        }
      },
      paymentDeleteStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      }
    },
    computed: {
      
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      options:{
        get () {  
          return this.$store.getters.getPaymentOptions;
        },
        set (value) {
          this.search='';
          this.$store.dispatch( 'setPaymentOptions', {options:value} )
        }
      },
      selectedDay:{
        get () {
          return this.$store.getters.getPaymentOptions.selectedDay;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedDay = value;
          this.options = currentOptions;
          //this.$store.dispatch( 'loadCourseLookup', {year_id:this.options.selectedCourse} );
        }
      },
      showDeleted: {
        get () {
          return this.$store.getters.getPaymentOptions.showDeleted;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.showDeleted = value;
          this.options = currentOptions;
        }
      },
      selectedSettlements:{
        get: function () {
          return this.editedItem.selectedSettlements;
        },
        // setter
        set: function (value) {
          this.$store.commit('setSelectedSettlements',value);
        }
      },
      editedItem(){
        return this.$store.getters.getPaymentEdit;
      },
      editedItemChildId(){
        return this.editedItem.child.id;
      },
      editedItemType(){
        return this.editedItem.type;
      },
      editedItemChildName(){
        if(this.editedItem.child.name)return this.editedItem.child.name+' '+this.editedItem.child.surname;
        else '';
      },
      editedItemAmountDec(){
        return parseFloat(this.editedItem.amount.toString().replace(',','.'));
      },
      editedItemAmountCur(){
        return i18n.n(this.editedItem.amount, 'currency', 'pl-PL')
      },
      tableItems(){
        return this.$store.getters.getPayments;
      },
      tableSettlements(){
        return this.editedItem.settlements;
      },
      tableSelected(){
        return this.editedItem.selected;
      },
      paymentsLoadStatus(){
        return this.$store.getters.getPaymentsLoadStatus;
      },
      paymentEditLoadStatus(){
        return this.$store.getters.getPaymentEditLoadStatus
      },
      paymentEditStatus(){
        return this.$store.getters.getPaymentEditStatus();
      },
      paymentEditText(){
        return this.$store.getters.getPaymentEditText
      },
      paymentEditing(){
        return this.$store.getters.getPaymentEditing;
      },
      childrenLookup() {
        return this.$store.getters.getChildrenLookup;
      },
       childrenLookupLoadStatus() {
        return this.$store.getters.getChildrenLookupLoadStatus;
      },
      paymentAddStatus(){
        return this.$store.getters.getPaymentAddStatus();
      },
      paymentAddText(){
        return this.$store.getters.getPaymentAddText;
      },
      paymentDeleteStatus(){
        return this.$store.getters.getPaymentDeleteStatus();
      },
      paymentSendDocumentStatus(){
        return this.$store.getters.getPaymentSendDocumentStatus();
      },
      settlementsLoadStatus(){
        return this.$store.getters.getSettlementsLoadStatus;
      },
      childLoadStatus(){
        return this.$store.getters.getChildLoadStatus;
      },
      child(){
        return this.$store.getters.getChild;
      },
      ownersWithEmail(){
        return this.child.owners.filter(c => c.email);
      },
      computedHeaders () {
        var localHeaders = [...this.headers.filter(h => h.display===true)]
        if(!this.showDeleted && this.user.permissions['payment'] <= 5) return localHeaders.filter(h => h.value!=='status' && h.value!=='actions')
        else if(this.showDeleted && this.user.permissions['payment'] <= 5) return localHeaders.filter(h => h.value!=='actions')
        else if(!this.showDeleted) return localHeaders.filter(h => h.value!=='status')
        else return localHeaders
      },
      formTitle () {
        if(this.itemViewing)return 'Podgląd dokumentu'
        return !this.paymentEditing ? 'Nowy dokument' : 'Edycja dokumentu'
      },
      child_idErrors() {
        const errors = [];
        if (!this.$v.editedItem.child.id.$dirty) return errors;
        !this.$v.editedItem.child.id.required &&
          errors.push("Dziecko jest wymagane");
        return errors;
      },
      // nameErrors () {
      //   const errors = []
      //   if (!this.$v.editedItem.name.$dirty) return errors
      //   !this.$v.editedItem.name.required && errors.push('Nazwa jest wymagana')
      //   !this.$v.editedItem.name.maxLength && errors.push('Nazwa może mieć maksymalnie 20 znaków')
      //   return errors
      // },
      amountErrors () {
        var action = this.editedItem.type=='KP'?'Wpłata':'Wypłata'
        var action2 = this.editedItem.type=='KP'?'do zapłaty':'zapłacona'

        const errors = []
        if (!this.$v.editedItem.amount.$dirty) return errors
        !this.$v.editedItem.amount.required && errors.push('Kwota jest wymagana')
        !this.$v.editedItem.amount.decimalPL && errors.push('Proszę wpisać poprawną kwotę.')
        //!this.$v.editedItemAmountDec.maxValue && errors.push(action+' nie może być wyższa niż suma '+action2)
        !this.$v.editedItemAmountDec.minValue && errors.push(action+' nie może być równa 0')
        return errors
      },
      selectedErrors () {
        if(!this.$v.editedItem.selected.$dirty) return '';
        if(!this.$v.editedItem.selected.required || !this.$v.editedItem.selected.minLength) return 'Wymagana co najmniej 1 pozycja';
      },
      maxValue(){
        if(this.editedItem.type=='KP')return this.sumField('amount')-this.sumField('posted_without_document');
        else return this.sumField('posted_without_document');
      },
    },
    mounted(){
      if(this.lookups.years.length>0){
        this.loadPayments();
      }else{
        this.$store.dispatch( 'loadLookups' );
        setTimeout(() => {
          this.loadPayments();
        }, 2000)
      }
    },
    methods: {
      loadPayments(){
        this.search='';
        var currentOptions = {...this.$store.getters.getPaymentOptions};
        var date = new Date(); 
        currentOptions.selectedType=['KP','KW'];
        currentOptions.selectedDay = date.toISOString().substr(0,10);
        this.$store.dispatch( 'setPaymentOptions', {options:currentOptions} )
      },
      loadMore(){
        this.$store.dispatch( 'loadMorePayments' );
      },
      
      editItem (item) {
        this.itemEditing = true
        this.itemViewing = false
        this.$store.dispatch( 'loadDocumentEdit', {slug:  item.id});  
        //this.$store.dispatch( 'loadSettlementsForChild', {child_id:item.child.id});
        this.dialog = true
      },
      viewItem (item) {
        this.itemEditing = true
        this.itemViewing = true
        this.$store.dispatch( 'loadDocumentEdit', {slug:  item.id});  
        //this.$store.dispatch( 'loadSettlementsForChild', {child_id:item.child.id});
        this.dialog = true
      },
      amountInput(){
        if (!this.$v.$invalid) {
          this.$store.commit('setRecalculateDocument',{user: this.user});
        }
      },
      // postedWithoutCurrentDocument(settlement){
      //   var key = 'amount';
      //   if(this.editedItem.id)
      //     return 1;//Vue._.filter(settlement.documents,function(o) { return o.id!=this.editedItem.id; }).reduce((a, b) => a + ((b && b[key])?b[key]:0 || 0), 0);
      //   else return 0;
      // },
      monthName(val){
        return Vue._.find(this.lookups.months, {'value':val}).text;
      },
      addSettlementToDocument(){
        this.selectedSettlements.forEach(element => {
            this.$store.commit('setAddToDocument',element);
        });
        this.selectedSettlements = []

        if (!this.$v.$invalid) {
          this.$store.commit('setRecalculateDocument',{user: this.user});
        }
      },
      deleteSettlementFromDocument(){
        this.selectedSelected.forEach(element => {
            this.$store.commit('setAddToSettlement',element);
        });
        this.selectedSelected = []

        if (!this.$v.$invalid) {
          this.$store.commit('setRecalculateDocument',{user: this.user});
        }
      },
      deleteItem (item) {
        if(item.storn){
          this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz usunąć dokument?<br />Rostanie również cofnięte storno dokumentu <b>'+item.storn.document_number +'</b> !', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'deleteDocument', {slug:  item.id});
             }
          })
        }else{
          this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz usunąć dokument?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'deleteDocument', {slug:  item.id});
             }
          })
        }
      },
      stornItem (id) {
        this.$refs.confirm.open('Storno', 'Czy na pewno chcesz stornować dokument?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'stornDocument', {slug:  id});
            }
        })
      },
      searchPayments(){
        if(this.search.length>2){
          const filterableHeaders = _.join(_.map(_.filter(this.headers,{'filterable':true}),'filterColumn'),';');
          this.$store.dispatch( 'searchPayments',{filterableHeaders:filterableHeaders,q:this.search.replace(/,/, ".")});
        }
      },
      close () {
        this.dialog = false
        this.componentKey += 1;
        this.searchReference = null
        this.selectedSettlements = []
        this.selectedSelected = []
        this.$v.$reset()
        setTimeout(() => {
          this.$store.dispatch( 'loadPaymentEditDefault'); 
          this.$store.dispatch( 'loadPaymentAddDefault');
          this.itemEditing = false
          this.itemViewing = false
        }, 300)
      },
      closeEmail () {
        this.dialogEmail = false
        this.$v.$reset()
        setTimeout(() => {
          this.$store.dispatch( 'loadChildEditDefault'); 
        }, 300)
      },
      querySelectionsReference(v) {
        this.$store.dispatch("searchChildrenLookup", { q: v, slug: 0 });
      },
      sumField(key) {
        return this.tableSelected.reduce((a, b) => a + ((b && b[key])?b[key]:0 || 0), 0);
      },
      sumFieldSettlements(key) {
        return this.tableSettlements.reduce((a, b) => a + ((b && b[key])?b[key]:0 || 0), 0);
      },
      generatePDF(){
        var items = []
        var lp = 1;
        var page = 1;
        this.tableSelected.sort((a,b)=>(a.lp>b.lp)?1:(b.lp>a.lp)?-1:0).forEach(item => {
          items.push([lp++,this.monthName(item.month), item.rates, i18n.n(this.editedItem.type=='KP'?(item.amount-item.posted_without_document):item.posted_without_document, 'currency', 'pl-PL'),
          i18n.n(item.payed, 'currency', 'pl-PL')]);
        });

        var doc = new jsPDF({
          //orientation: 'landscape',
          unit: 'mm',
          format: 'a4',
        })
        var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
        var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

        doc.setFont("Roboto-Medium", "bold"); // set font
        doc.setFontSize(18);
        doc.addImage(logusLogo, 'PNG', 5, 5, 22.5, 20);
        doc.text(this.editedItem.document_number, pageWidth / 2, 18, {align:'center',baseline:'bottom'});
        doc.setFontSize(12);
        doc.text(this.editedItem.child.name+' '+this.editedItem.child.surname, pageWidth-5, 12, {align:'right'});
        doc.setFont("Roboto-Regular", "normal"); // set font
        doc.setFontSize(10);
        doc.autoTable({
          didDrawPage: (data) => {
            doc.text(page.toString(), 5, pageHeight-5);
            doc.text(this.editedItem.created_by+' / '+this.editedItem.created_at, pageWidth-5, pageHeight-5, {align:'right'});
            page++;
          },
          theme:'grid',
          styles:{font:'Roboto-Regular', fontSize:9 },
          headStyles: { fillColor: [210, 210, 210],textColor:20 },
          footStyles: { fillColor: [210, 210, 210],textColor:20 },
          startY: 30,
          showFoot:'lastPage',
          margin: {top:5,bottom:10,left:5,right:5},
          columnStyles: { 3: {font:'Roboto-Medium',fontStyle:'bold', halign: 'right' },4: {font:'Roboto-Medium',fontStyle:'bold', halign: 'right' } },
          head: [[''].concat(Vue._.map(this.headersSelected,'text'))],
          body: items,
          foot: [
            [
              { content: 'Suma', colSpan: 3, styles: {font:'Roboto-Medium',fontStyle:'bold', halign: 'right' } },
              { content:i18n.n(this.editedItem.type=='KP'?(this.sumField('amount')-this.sumField('posted_without_document')):this.sumField('posted_without_document'), 'currency', 'pl-PL'),styles: {font:'Roboto-Medium',fontStyle:'bold',halign: 'right' }},
              { content:i18n.n(this.sumField('payed'), 'currency', 'pl-PL'),styles: {font:'Roboto-Medium',fontStyle:'bold',halign: 'right' }}],
          ],
        })
        
        return doc;
      },
      printFile(){
        var doc = this.generatePDF();
        doc.autoPrint();
        doc.output('dataurlnewwindow');
      },

      sendFileLoad(){
        this.dialogEmail = true;
        this.$store.dispatch("loadChildOwner", { slug: this.editedItem.child.id });
      },
      sendFile(item){
        var doc = this.generatePDF();
        var res = doc.output('datauristring',{filename:this.editedItem.child.name+'_'+this.editedItem.child.surname+'_'+this.editedItem.document_number+'.pdf'});
        this.$store.dispatch("sendPaymentDocument", { child_id: this.editedItem.child.id,owner_id:item.id,document:res });
        //console.log(item.email);
      },
     handleSubmit () {
         this.$v.$touch()
         if (this.$v.$invalid) {

         } else {
             if (this.itemEditing) {
                this.$store.dispatch( 'editDocument', {
                  slug: this.editedItem.id,
                  type:  this.editedItem.type,
                  child_id: this.editedItem.child.id,
                  amount: this.editedItem.amount.toString().replace(/\./g, "").replace(/,/, "."),
                  selected: Vue._.map(this.editedItem.selected,function (s) {return {id:s.id,payed:s.payed,payed_stay:s.payed_stay,payed_meal:s.payed_meal,payed_other:s.payed_other}}),
                  source:this.editedItem.source,
                });
             } else {//new item
                this.$store.dispatch( 'addDocument', {
                  type:  this.editedItem.type,
                  child_id: this.editedItem.child.id,
                  amount: this.editedItem.amount.toString().replace(/\./g, "").replace(/,/, "."),
                  selected: Vue._.map(this.editedItem.selected,function (s) {return {id:s.id,payed:s.payed,payed_stay:s.payed_stay,payed_meal:s.payed_meal,payed_other:s.payed_other}}),
                  source:this.editedItem.source,
                });
             }
          }
       },
    },
  }
</script>


<style scoped>
.search{
      max-width: 200px;
}
.choose_date{
      max-width: 150px;
}
</style>